import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { PayrollSettingsPage } from '../../../features/payroll/settings-page'

/** Read with payroll.read, changed with payroll.settings. */
export const Route = createFileRoute('/_app/payroll/settings')({
  staticData: { crumb: 'payrollSettings' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'payroll.read'),
  component: PayrollSettingsPage,
})
